<template lang="pug">
  .folder-card-container.column.card-container.relative
    .placeholder.image.absolute
    .placeholder.title.m-bottom-1
    .placeholder.hashtag
    .placeholder.ages.m-top-auto
</template>

<script>

export default {

}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.folder-card-container{
  height: 150px;
  width: 100%;
  background-color: $white;
  margin: 0;
  padding: 10px;
  padding-top: 15px;
  border-radius: 10px;
  overflow: hidden;
}
.placeholder{
  background-color: $light-gray;
  &.title{
    height: 30px;
    width: 250px;
  }
  &.hashtag{
    height: 18px;
    width: 100px;
  }
  &.ages{
    height: 18px;
    width: 200px;
  }
  &.image{
    transform: rotate(-45deg);
    border-radius: 15px;
    right: 10px;
    bottom: -22px;
    height: 110px;
    width: 80px;
  }
}
</style>
